import { useEffect, useState, useCallback } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setLoader } from 'redux/index';
import { getCalendarActivity } from 'services';
import { LifebookNav, PageLayout } from 'components';
import { useCreateDispatches } from 'helpers/hooks';
import MobileHeader from 'components/Headers/MobileHeader';
import { useCalendarActivityMapper } from '../utils/useCalendarActivityMapper';
import { useGetCalendarActivity } from '../utils/useGetCalendarActivity';
import styles from './calendarActivity.module.css';

const CalendarActivity = ({ returnBase = '/calendar' }) => {
	const isMd = useSelector((state) => state.mediaQuery.isMd);
	const child = useSelector((state) => state.lifebooks.child);
	const isCaseManager = useSelector(
		(state) => state.user.user.type === 'case-manager'
	);

	const [activity, setActivity] = useState(null);
	const [lastEventActivityId, setLastEventActivityId] = useState(null);
	const [isLoading, setIsLoading] = useState(false);

	const dispatch = useDispatch();
	const { setSnackbar } = useCreateDispatches();
	const dispatchLoader = (val) => dispatch(setLoader(val));
	const { push } = useHistory();
	const { childId } = useParams();

	useEffect(() => {
		if (!child.id) {
			push(returnBase);
		}
	}, [child.id, push, returnBase]);

	const getActivity = useGetCalendarActivity({
		setActivity,
		setLastEventActivityId,
	});

	const populateActivityFeed = useCallback(async () => {
		dispatchLoader(true);
		setIsLoading(true);
		await getActivity({ childId }).finally(() => {
			setIsLoading(false);
			dispatchLoader(false);
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [childId]);

	useEffect(() => {
		populateActivityFeed();
	}, [populateActivityFeed]);

	const handleScroll = (e) => {
		const { scrollTop, scrollHeight, clientHeight } = e.target;
		if (
			activity &&
			activity.length &&
			lastEventActivityId &&
			!isLoading &&
			scrollTop >= scrollHeight - clientHeight - 5
		) {
			lazyLoadActivity();
		}
	};

	const lazyLoadActivity = async () => {
		if (lastEventActivityId) {
			dispatchLoader(true);
			setIsLoading(true);
			await getCalendarActivity({ childId }, lastEventActivityId)
				.then((result) => {
					setActivity([...activity, ...result.data.eventActivities]);
					setLastEventActivityId(
						result.data.lastEventActivityId || null,
					);
					setIsLoading(false);
					dispatchLoader(false);
				})
				.catch((err) => {
					setIsLoading(false);
					dispatchLoader(false);
					setSnackbar(
						{ variant: 'error', message: err.response?.data.message },
						{ log: true }
					);
				});
		}
	};

	const activityMapper = useCalendarActivityMapper(lastEventActivityId);

	const activityMap =
		activity && activity.length && activity.map(activityMapper);

	return (
		<PageLayout
			header={isMd && !isCaseManager ? <MobileHeader /> : null}
			footer={<LifebookNav />}
			showChildContext={isCaseManager}
			title={`${child.firstname} ${child.lastname}'s Calendar`}>
			<div className={styles.activityFeedRoot} onScroll={handleScroll}>
				{activity ? (
					activity.length ? (
						activityMap
					) : (
						<div className={styles.noPostRoot}>
							<img src='/assets/ella-elephant.svg' alt='Ella Elephant' />
							<div className={styles.noPostTitle}>{'No Activities Found'}</div>
						</div>
					)
				) : null}
			</div>
		</PageLayout>
	);
};

export default CalendarActivity;
